export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '全网首发聚合',
    desc: '智能抓取50+主流内容源，第一时间呈现全网最新吃瓜热点，告别多平台切换烦恼，一站式浏览更高效。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多线路稳定访问',
    desc: '自研智能路由系统，多节点实时切换，无论何时何地都能稳定访问官方入口，永不断线保障浏览体验。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '极速实时更新',
    desc: '7×24小时不间断监控热点动态，AI辅助内容检测，从事件爆发到上架平均仅需3分钟，快人一步掌握最新进展。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端无缝覆盖',
    desc: '网页版、轻量版、iOS/Android客户端全平台支持，数据云端同步，在家里、在路上、在办公室随时切换设备继续浏览。',
  },
  {
    icon: 'ri-lock-line',
    title: '隐私安全保障',
    desc: '不强制注册、不追踪个人行为、浏览记录本地加密存储，严格保护用户隐私安全，让你安心吃瓜无后顾之忧。',
  },
];

export const appEntry = {
  title: '51吃瓜客户端下载',
  subtitle: '支持iOS / Android / 轻量版网页端，多平台无缝切换',
  desc: '轻量版安装包仅8MB，极速启动不占内存；完整版APP支持离线缓存、夜间模式、推送提醒等高级功能。扫描二维码或点击下方按钮即可下载最新版本客户端。',
  qrLabel: '扫码下载',
  version: 'v4.2.1',
  updateDate: '2026年7月28日更新',
};

export const updateItems = [
  { date: '2026-07-29', time: '14:32', tag: '最新爆料', title: '某顶流艺人疑似恋情曝光，工作室紧急回应引发全网热议' },
  { date: '2026-07-29', time: '11:15', tag: '热点追踪', title: '热播剧大结局收视率创新高，主演发文告别角色引粉丝泪目' },
  { date: '2026-07-29', time: '09:08', tag: '圈内动态', title: '知名综艺节目官宣新一季阵容，多位实力派加盟备受期待' },
  { date: '2026-07-28', time: '22:40', tag: '独家深扒', title: '娱乐圈豪门婚礼细节曝光，奢华程度超乎想象引网友围观' },
  { date: '2026-07-28', time: '18:55', tag: '音乐前线', title: '华语乐坛天王新专辑上线首日销量破纪录，乐评人一致好评' },
  { date: '2026-07-28', time: '15:20', tag: '影视速递', title: '暑期档票房大战白热化，国产动画电影异军突起成最大黑马' },
  { date: '2026-07-28', time: '10:45', tag: '热搜速报', title: '某品牌代言人更换风波持续发酵，多方回应让事件更加扑朔迷离' },
  { date: '2026-07-27', time: '20:30', tag: '综艺直播', title: '直播综艺新模式引发行业讨论，观众互动率飙升创历史新高' },
  { date: '2026-07-27', time: '16:18', tag: '时尚八卦', title: '国际时装周亚洲面孔大放异彩，中国设计师作品获全球媒体盛赞' },
];

export const mediaItems = [
  {
    title: '独家解析：本周十大热搜事件全回顾',
    duration: '08:42',
    views: '128.6万',
    date: '2026-07-28',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20entertainment%20news%20video%20thumbnail%20with%20colorful%20collage%20of%20Chinese%20celebrity%20headlines%2C%20warm%20coral%20and%20amber%20gradient%20background%2C%20modern%20editorial%20design%20with%20dynamic%20typography%2C%20clean%20geometric%20accents%2C%20professional%20news%20media%20style&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '深度揭秘：娱乐圈那些你不知道的背后故事',
    duration: '12:15',
    views: '96.3万',
    date: '2026-07-27',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20documentary%20style%20thumbnail%20with%20dramatic%20lighting%2C%20behind%20the%20scenes%20aesthetic%2C%20warm%20magenta%20and%20gold%20tones%2C%20film%20noir%20inspired%20composition%2C%20mysterious%20atmosphere%20with%20spotlight%20effect&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '实时追踪：最新爆款话题完整时间线梳理',
    duration: '06:28',
    views: '215.7万',
    date: '2026-07-29',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20timeline%20visualization%20thumbnail%20with%20glowing%20nodes%20and%20connection%20lines%2C%20dark%20background%20with%20warm%20coral%20and%20amber%20accents%2C%20futuristic%20data%20tracking%20aesthetic%2C%20clean%20modern%20interface%20design%20elements&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
];

export const aboutContent = {
  title: '关于51吃瓜网',
  paragraphs: [
    '51吃瓜网今日吃瓜资源成立于2020年，是国内领先的娱乐资讯聚合平台。我们致力于为用户提供全网最新、最全、最及时的吃瓜内容，涵盖明星动态、综艺热点、影视资讯、时尚八卦、社会趣闻等多个领域。',
    '平台通过自主研发的智能聚合引擎，实时监控50+主流内容源，利用AI算法精准识别高价值热点内容，确保用户不错过任何一条值得关注的娱乐资讯。无论是网页版、轻量版还是APP客户端，我们都提供一致流畅的浏览体验。',
    '我们始终坚持以用户体验为核心，不强制注册、不捆绑推广、不过度商业化，让每一位访问者都能在清爽整洁的界面中享受纯粹的吃瓜乐趣。同时，我们严格执行内容审核标准，杜绝虚假信息和恶意炒作，为用户营造健康、真实的资讯环境。',
    '截至目前，51吃瓜网已累计服务超过800万用户，日均内容更新量超过200条，覆盖全国300+城市。未来我们将持续优化技术架构和内容质量，努力成为中文互联网最值得信赖的吃瓜内容平台。',
  ],
};

export const cardItems = [
  {
    title: '暑期档综艺大盘点：谁才是真正的收视王者',
    tag: '综艺热评',
    date: '2026-07-29',
    excerpt: '今年暑期档综艺市场竞争异常激烈，各大平台纷纷祭出王牌节目，收视率和口碑的较量进入白热化阶段...',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20spotlights%20and%20cheerful%20atmosphere%2C%20warm%20coral%20and%20gold%20lighting%2C%20entertainment%20industry%20aesthetic%2C%20clean%20composition%20with%20vibrant%20colors&width=400&height=250&seq=card-item-01&orientation=landscape',
  },
  {
    title: '华语音乐榜中榜：本周最值得循环播放的热歌',
    tag: '音乐推荐',
    date: '2026-07-28',
    excerpt: '本周华语乐坛迎来多首重磅新歌发布，从流行到民谣，从电子到R&amp;B，各种风格百花齐放令人目不暇接...',
    img: 'https://readdy.ai/api/search-image?query=Music%20studio%20atmosphere%20with%20warm%20amber%20lighting%20and%20vinyl%20records%2C%20vintage%20aesthetic%20blended%20with%20modern%20elements%2C%20soft%20glow%20from%20studio%20monitors%2C%20artistic%20music%20theme&width=400&height=250&seq=card-item-02&orientation=landscape',
  },
  {
    title: '明星私服穿搭解析：本季最值得借鉴的时尚法则',
    tag: '时尚潮流',
    date: '2026-07-28',
    excerpt: '随着各大品牌秋冬系列陆续发布，明星们的私服穿搭也愈发精彩。从机场街拍到活动红毯，每一套都值得细细品味...',
    img: 'https://readdy.ai/api/search-image?query=Fashion%20editorial%20photography%20with%20elegant%20clothing%20on%20display%2C%20warm%20neutral%20background%20with%20soft%20magenta%20accents%2C%20minimalist%20composition%2C%20luxury%20fashion%20aesthetic%2C%20clean%20lighting&width=400&height=250&seq=card-item-03&orientation=landscape',
  },
  {
    title: '网剧市场新风向：短剧赛道正在重塑内容格局',
    tag: '行业观察',
    date: '2026-07-27',
    excerpt: '近年来短剧市场迎来爆发式增长，各大平台纷纷加码布局。从制作水准到商业模式，短剧正在经历前所未有的变革...',
    img: 'https://readdy.ai/api/search-image?query=Modern%20film%20production%20set%20with%20professional%20camera%20equipment%2C%20warm%20coral%20lighting%2C%20cinematic%20behind%20the%20scenes%20aesthetic%2C%20clean%20composition%20with%20creative%20atmosphere&width=400&height=250&seq=card-item-04&orientation=landscape',
  },
  {
    title: '饭圈文化进化论：从追星到共创的社群变革',
    tag: '深度分析',
    date: '2026-07-27',
    excerpt: '饭圈文化正在经历深层次的变革，从单纯的追星行为演变出更多元化的社群形态。粉丝经济的新模式值得我们深入探讨...',
    img: 'https://readdy.ai/api/search-image?query=Community%20gathering%20atmosphere%20with%20colorful%20glow%20sticks%20and%20warm%20celebration%20vibe%2C%20soft%20amber%20and%20magenta%20lighting%2C%20concert%20crowd%20energy%2C%20artistic%20blur%20effect&width=400&height=250&seq=card-item-05&orientation=landscape',
  },
  {
    title: '下半年待播剧清单：你最期待的IP改编是哪部',
    tag: '追剧指南',
    date: '2026-07-26',
    excerpt: '2026年下半年待播剧集阵容豪华，多部重磅IP改编作品即将与观众见面。我们为大家整理了最值得期待的十部作品...',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20dramatic%20lighting%20and%20warm%20color%20palette%2C%20film%20strip%20elements%2C%20coral%20and%20gold%20gradient%20overlay%2C%20professional%20entertainment%20industry%20design&width=400&height=250&seq=card-item-06&orientation=landscape',
  },
];

export const faqItems = [
  {
    q: '51吃瓜网是什么类型的平台？',
    a: '51吃瓜网是一个专注于娱乐资讯聚合的内容平台，汇集全网最新、最热的明星八卦、综艺热点、影视资讯、时尚潮流等多元化内容。我们通过智能算法实时抓取50+主流内容源，为用户提供一站式吃瓜体验。平台提供网页版、轻量版和手机APP三种访问方式，完全免费使用。',
  },
  {
    q: '如何下载51吃瓜APP客户端？',
    a: '您可以通过本页面的"移动端入口"区域扫描二维码或点击下载按钮获取最新版本的51吃瓜APP。目前支持iOS和Android双平台，轻量版安装包仅8MB大小，下载速度快、占用空间小。建议从官方渠道下载以确保安全性和功能的完整性。',
  },
  {
    q: '轻量版和完整版APP有什么区别？',
    a: '轻量版针对网络环境受限或手机存储空间有限的用户设计，安装包仅8MB，核心浏览功能完整，加载速度快。完整版APP额外支持离线缓存（可预先下载内容在没有网络时阅读）、夜间模式、个性化推送、收藏同步等高级功能，安装包约35MB，推荐存储空间充裕的用户使用。',
  },
  {
    q: '访问入口失效了怎么办？',
    a: '51吃瓜网采用智能路由和多节点部署架构，当某个访问入口出现波动时，系统会自动切换到备用线路。如果您遇到访问问题，可以尝试以下方式：1）刷新当前页面；2）清除浏览器缓存后重新访问；3）使用本站提供的轻量版入口；4）下载APP客户端获得最稳定的访问体验。我们的技术团队7×24小时监控服务状态，确保第一时间修复异常。',
  },
  {
    q: '使用51吃瓜网需要注册吗？',
    a: '不需要。51吃瓜网始终坚持"无障碍浏览"理念，所有内容均可免费直接访问，无需注册账号。我们不强制收集用户个人信息，不要求绑定手机号或邮箱。如果您希望使用收藏、评论互动、个性化推荐等高级功能，可选择自愿注册，但这完全不是必需的。我们尊重每一位用户的选择。',
  },
  {
    q: '平台内容更新频率如何？',
    a: '51吃瓜网实行7×24小时不间断更新机制，日均更新内容超过200条。我们的智能聚合引擎实时监控全网热点，从事件爆发到内容上架平均仅需3分钟。同时配备专业编辑团队进行内容质量审核，确保每一条信息的真实性和可读性。重大热点事件发生时，我们会启动应急更新机制，以最快速度提供全方位追踪报道。',
  },
];

export const commentItems = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20cute%20watermelon%20character%20avatar%20in%20flat%20design%20style%2C%20warm%20coral%20colors%2C%20minimalist%20vector%20art%2C%20clean%20white%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2小时前',
    content: '这个平台真的太方便了！以前要切换好几个APP才能看完一天的八卦，现在打开51吃瓜网一个就够了，更新速度还特别快。强烈推荐给所有吃瓜爱好者！',
    likes: 328,
  },
  {
    name: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20detective%20magnifying%20glass%20character%20avatar%20in%20flat%20design%2C%20warm%20amber%20colors%2C%20minimalist%20vector%20style%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '5小时前',
    content: '轻量版APP真的太好用了，才8MB一点也不占地方，加载速度还快。上班摸鱼的时候偷偷刷一下，同事都问我怎么知道的八卦比他们还多哈哈。',
    likes: 256,
  },
  {
    name: '追风少年阿瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Playful%20melon%20slice%20mascot%20avatar%20in%20flat%20illustration%20style%2C%20vibrant%20coral%20and%20green%20colors%2C%20minimalist%20design%2C%20clean%20white%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '8小时前',
    content: '从2021年就开始用51吃瓜网了，见证了它从一个小站点成长为现在的大平台。内容质量一直很稳定，而且不像有些平台那样全是标题党和广告，体验真的很良心。',
    likes: 189,
  },
  {
    name: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20night%20owl%20with%20popcorn%20character%20avatar%20in%20flat%20design%2C%20warm%20magenta%20colors%2C%20minimalist%20vector%20art%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '12小时前',
    content: '夜间模式简直是熬夜党的福音！而且不用注册就能看所有内容这点真的很赞，现在太多平台不登录连首页都看不了，51吃瓜网这一点做得很人性化。',
    likes: 412,
  },
];

export const topicItems = [
  { name: '夏日限定综艺', heat: '987万', trend: 'up', tag: '爆' },
  { name: '明星机场私服', heat: '856万', trend: 'up', tag: '热' },
  { name: '暑期档票房榜', heat: '823万', trend: 'up', tag: '热' },
  { name: '新歌首发打榜', heat: '765万', trend: 'up', tag: '热' },
  { name: '综艺名场面', heat: '712万', trend: 'stable', tag: '新' },
  { name: '明星情侣日常', heat: '698万', trend: 'down', tag: '' },
  { name: '影视剧路透', heat: '654万', trend: 'up', tag: '新' },
  { name: '时尚品牌代言', heat: '621万', trend: 'stable', tag: '' },
  { name: '饭圈创作大赛', heat: '587万', trend: 'up', tag: '' },
  { name: '经典老剧翻红', heat: '543万', trend: 'up', tag: '' },
  { name: '直播带货翻车', heat: '521万', trend: 'down', tag: '爆' },
];

export const rankingItems = [
  { rank: 1, title: '顶流艺人恋情疑曝光：工作室深夜紧急发声明回应网络传闻', heat: '1256万', change: 'new' },
  { rank: 2, title: '热播剧大结局创今年收视最高纪录：主演直播告别引500万人围观', heat: '1089万', change: 'up' },
  { rank: 3, title: '某知名导演新片阵容官宣：三位影帝同框引全网期待值爆表', heat: '967万', change: 'up' },
  { rank: 4, title: '音乐盛典获奖名单揭晓：新生代歌手包揽三项大奖成最大赢家', heat: '892万', change: 'up' },
  { rank: 5, title: '综艺节目录制现场意外曝光：节目组紧急回应称正在调查处理中', heat: '834万', change: 'down' },
  { rank: 6, title: '国产科幻动画电影口碑逆袭：上映首周票房突破3亿远超预期', heat: '776万', change: 'up' },
  { rank: 7, title: '国际品牌官宣新代言人：中国面孔再登全球广告引国人自豪热议', heat: '721万', change: 'new' },
];

export const indexItems = [
  { category: '明星八卦', count: 1256, icon: 'ri-star-line', desc: '最新明星动态与独家爆料' },
  { category: '综艺节目', count: 987, icon: 'ri-tv-line', desc: '热门综艺资源全收录' },
  { category: '影视资讯', count: 865, icon: 'ri-film-line', desc: '院线新片与网剧速递' },
  { category: '音乐潮流', count: 754, icon: 'ri-music-line', desc: '华语乐坛最新动向' },
  { category: '时尚穿搭', count: 632, icon: 'ri-t-shirt-line', desc: '明星私服与潮流解析' },
  { category: '社会热点', count: 589, icon: 'ri-fire-line', desc: '热门社会话题讨论' },
  { category: '数码科技', count: 478, icon: 'ri-smartphone-line', desc: '科技圈最新爆料' },
  { category: '体育赛事', count: 421, icon: 'ri-basketball-line', desc: '体坛热点追踪' },
  { category: '直播互动', count: 398, icon: 'ri-live-line', desc: '直播圈动态速递' },
];

export const carouselItems = [
  {
    title: '2026暑期档全回顾',
    tag: '焦点专题',
    excerpt: '从票房黑马到口碑神作，这个夏天荧幕上发生了太多精彩故事。我们为你梳理暑期档最值得关注的十件大事。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20collage%20with%20dramatic%20warm%20lighting%2C%20film%20reel%20and%20popcorn%20elements%2C%20coral%20and%20gold%20gradient%2C%20entertainment%20industry%20editorial%20design%2C%20vibrant%20summer%20atmosphere&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '新生代艺人崛起之路',
    tag: '深度人物',
    excerpt: '2026年无疑是新生代艺人集中爆发的一年。从选秀舞台到银幕中心，他们的成长故事比任何剧本都精彩。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20portrait%20silhouette%20on%20stage%20with%20dramatic%20spotlight%20effect%2C%20warm%20magenta%20and%20amber%20tones%2C%20rising%20star%20concept%2C%20cinematic%20composition%2C%20inspirational%20atmosphere&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '饭圈文化变迁观察',
    tag: '行业洞察',
    excerpt: '从打榜到共创，从对立到对话，中国粉丝文化正在经历一场深刻的自我进化。我们记录了这一转变的关键节点。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20community%20gathering%20with%20glow%20sticks%20creating%20warm%20light%20ocean%2C%20concert%20atmosphere%2C%20coral%20and%20gold%20lighting%2C%20sense%20of%20unity%2C%20artistic%20crowd%20photography%20style&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '下半年娱乐前瞻',
    tag: '未来趋势',
    excerpt: 'AI短剧、虚拟偶像、互动综艺……2026年下半年，娱乐行业将迎来哪些新的变革？我们提前为你划重点。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20entertainment%20technology%20concept%20with%20holographic%20displays%20and%20warm%20ambient%20lighting%2C%20digital%20art%20aesthetic%2C%20coral%20and%20amber%20gradient%2C%20innovative%20media%20design%2C%20clean%20modern%20composition&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
];

export const contactContent = {
  title: '联系我们',
  subtitle: '投稿爆料 / 商务合作 / 问题反馈',
  desc: '如果您有独家爆料线索、商务合作意向或在使用过程中遇到任何问题，欢迎通过以下方式联系我们。我们会在24小时内回复您的每一条消息。',
  email: 'contact@51chigua.com',
  wechat: '51chigua_official',
  qq: '800123456',
};

export const footerLinks = {
  about: [
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '用户协议', href: '#' },
  ],
  download: [
    { label: 'iOS客户端', href: '#app' },
    { label: 'Android客户端', href: '#app' },
    { label: '轻量版入口', href: '#app' },
    { label: '历史版本', href: '#' },
  ],
  hot: [
    { label: '焦点专题', href: '#carousel' },
    { label: '热搜榜单', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '吃瓜索引', href: '#index' },
  ],
};